import { render, staticRenderFns } from "./calendarMoment.vue?vue&type=template&id=c846e538"
import script from "./calendarMoment.vue?vue&type=script&lang=js"
export * from "./calendarMoment.vue?vue&type=script&lang=js"
import style0 from "./calendarMoment.vue?vue&type=style&index=0&id=c846e538&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports